// import React from "react";
// import { COLORS, CHART_COLORS } from "../constants/analyticsConstants";
import { fmtDate,fmtTime, fmtEventName, colorForCode } from "../utils/analyticsUtils";

/* ── Badge variants by meaning ─────────────────────────────────────────── */
function Pill({ label, variant = "neutral" }) {
  return <span className={`ua-badge ua-badge-${variant}`}>{label}</span>;
}

/* Screen name → badge variant */
const screenVariant = (screen = "") => {
  if (/splash|home|lifestyle/i.test(screen)) return "info";
  if (/otp|verif|login/i.test(screen))       return "warn";
  if (/vital|heart|rate/i.test(screen))      return "success";
  if (/language|select/i.test(screen))       return "neutral";
  return "purple";
};

/* Element → variant */
const elVariant = () => "warn";

/* ── Session card ───────────────────────────────────────────────────────── */
function JourneySession({ session, index }) {
  const events     = session.events ?? [];
  const sessionId  = session._id;
  const anonId     = session.anonymous_id;
  const platform   = events.find(e => e.device_info)?.device_info?.platform;
  const durationMs = session.session_start && session.session_end
    ? new Date(session.session_end) - new Date(session.session_start) : null;
  const durationMin = durationMs != null ? Math.round(durationMs / 60000) : null;

  /* Stripe color cycles per session */
  const stripeGrads = [
    "linear-gradient(180deg,#818CF8,#4F46E5)",
    "linear-gradient(180deg,#34D399,#059669)",
    "linear-gradient(180deg,#60A5FA,#1D4ED8)",
    "linear-gradient(180deg,#F472B6,#9D174D)",
  ];
  const stripe = stripeGrads[index % stripeGrads.length];

  return (
    <div className="ua-j-card" style={{ animationDelay: `${index * .08}s` }}>
      <div className="ua-j-card-inner">
        {/* Colored left stripe */}
        <div className="ua-j-stripe" style={{ background: stripe }} />

        <div className="ua-j-body">
          {/* Header */}
          <div className="ua-j-header">
            <div className="ua-j-meta">

              <div className="ua-j-title">
                  Session {index + 1}
                  {session.session_start && (
                    <span style={{ marginLeft: 8, fontSize: 12, color: "var(--t3)" }}>
                      • {fmtDate(session.session_start)}
                    </span>
                  )}
                </div>

              <div className="ua-j-id">{sessionId}</div>
              {anonId && <div style={{ fontSize: 11, color: "var(--t3)", marginTop: 2 }}>{anonId}</div>}
            </div>

            <div className="ua-j-chips">
              {platform && (
                <div className="ua-j-stat">
                  <span className="ua-j-stat-icon">📱</span>
                  {platform}
                </div>
              )}
              {durationMin != null && (
                <div className="ua-j-stat">
                  <span className="ua-j-stat-icon">⏱</span>
                  {durationMin} min
                  <span className="ua-j-stat-label">duration</span>
                </div>
              )}
              <div className="ua-j-stat">
                <span className="ua-j-stat-icon">⚡</span>
                {events.length}
                <span className="ua-j-stat-label">events</span>
              </div>
            </div>
          </div>

          {/* Timeline */}
          <div className="ua-timeline">
            {events.map((ev, i) => {
              const isLast = i === events.length - 1;
              const color  = colorForCode(ev.event_code);
              const bg     = color + "18";
              return (
                <div key={i} className="ua-tl-row">
                  {/* Node + connector */}
                  <div className="ua-tl-col">
                    <div
                      className="ua-tl-node"
                      style={{
                        background: bg,
                        border: `2px solid ${color}`,
                        color,
                        boxShadow: `0 2px 8px ${color}33`,
                      }}
                    >
                      {i + 1}
                    </div>
                    {!isLast && <div className="ua-tl-line" />}
                  </div>

                  {/* Detail */}
                  <div className="ua-tl-detail">
                    <div className="ua-tl-event-row">
                      <span className="ua-tl-name">{fmtEventName(ev.event_name)}</span>
                    </div>
                    <div className="ua-tl-badges">
                      {ev.screen  && <Pill label={ev.screen}  variant={screenVariant(ev.screen)} />}
                      {ev.element && <Pill label={ev.element} variant={elVariant()} />}
                    </div>
                    <div className="ua-tl-time">
                      {fmtTime(ev.timestamp)}
                      <span className="ua-tl-code">code {ev.event_code}</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Tab root ───────────────────────────────────────────────────────────── */
export default function JourneysTab({ data }) {
  const journeys = data?.user_journey ?? [];
  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontFamily:"var(--fd)", fontSize:18, fontWeight:800, color:"var(--t1)", letterSpacing:"-.02em", margin:0 }}>
          User Journeys
        </h2>
        <p style={{ fontSize:13, color:"var(--t3)", marginTop:4 }}>
          {journeys.length} session{journeys.length !== 1 ? "s" : ""} · full event trace
        </p>
      </div>
      {journeys.length === 0
        ? <p style={{ color:"var(--t3)", fontSize:14 }}>No journey data available.</p>
        : journeys.map((session, i) => (
            <JourneySession key={session._id} session={session} index={i} />
          ))
      }
    </div>
  );
}